<template>
    <div class="gradeList">
        <div v-if="gradeList&&gradeList.length">
            <AddBtn name="添加成绩记录" path="/consultant/minestudent/main/studentMessage/grade/add"></AddBtn>
            <GradeListTable
                :gradeList="gradeList"
                :userType="userType"
                :pageData="pageData"
            ></GradeListTable>
            <Pagination :pageData="pageData" @changePage="changeCurrent" v-show="pageData.total>pageData.pageSize"></Pagination>
        </div>
        <Add
            v-else-if="gradeList&&gradeList.length==0"
            path='/consultant/minestudent/main/studentMessage/grade/add'
            name="暂无成绩记录，现在"
        />
    </div>
</template>
<script>
import Add from '@/components/consultant/Add.vue'
import AddBtn from '@/components/consultant/AddBtn.vue'
import GradeListTable from '@/components/consultant/GradeListTable.vue'
import Pagination from '@/components/consultant/Pagination.vue'
export default {
    name: "gradeList",
    components: {
        Add,AddBtn,
        GradeListTable,
        Pagination
    },
    data() {
        return {
            userType: 3,
            studentId: sessionStorage.getItem('myStudentStudentId'),
            gradeList: null,
            pageData: {
                current:1,//当前页
                pageSize:10,//每页多少条
                totalPage:1,//总页数数
                total:1//总条数
            }
        }
    },
    computed: {
    },
    created() {
        console.log(this.studentId)
        this.getAchievementList(this.studentId,this.pageData,1);
    },
    methods: {
        changeCurrent(value) {
            let current = value;
            this.getAchievementList(this.studentId,this.pageData,current);
        },
        // 获取成绩列表
        getAchievementList(studentId,pageData,current){
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.grade.getAchievementList, {
                studentId: studentId,
                pageSize: pageData.pageSize,
                pageNumber: current
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    let page = res.data.data.page;
                    this.gradeList = res.data.data.list;
                    this.pageData={
                        current:page.pageNumber,//当前页
                        pageSize:page.pageSize,//每页多少条
                        totalPage:page.count,//总页数数
                        total:page.count//总条数
                    };
                }else{

                }
            })
        },
    }

}
</script>

<style scoped lang="less">
.gradeList {
    background-color: #fff;
    padding: 0 20px;
    min-height: 600px;
    .addBtn {
        height: 32px;
        margin-bottom: 20px;
        .btn {
            float: right;
            width: 150px;
            height: 32px;
            background: linear-gradient(305deg, #3d90f6 0%, #2CB2FF 100%, #2CB2FF 100%);
            border-radius: 2px;
            border: 1px solid #D9D9D9;
            font-size: 16px;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
        }
    }
}
</style>